import type { Theme } from '@mui/material';

export const styles = {
  legendWrapper: (theme: Theme) => ({
    borderTop: `1px solid ${theme.colors.neutral[100]}`,
    pt: 3,
    pb: 0.75,
  }),

  legendIcon: (theme: Theme) => ({
    color: theme.colors.secondary[100],
  }),

  legendLabel: {
    fontSize: '0.875rem',
    pl: '0.5rem',
    pt: '0.125rem',
  },
};
